import { Query, QueryClient } from "@tanstack/react-query";
import { searchKeys } from "src/api/client/extended-search.api";
import { SEARCH_TABLE_MAX_CACHED_ROWS } from "src/components/pages/search/components/table/consts";

export const getMaxCachedSearchTablePages = (pageSize: number): number => {
    if (!Number.isFinite(pageSize) || pageSize < 1) {
        return 1;
    }

    return Math.max(1, Math.floor(SEARCH_TABLE_MAX_CACHED_ROWS / pageSize));
};

const leastRecentlyFetchedFirst = (left: Query, right: Query) => left.state.dataUpdatedAt - right.state.dataUpdatedAt;

export const limitSearchTablePageCache = (queryClient: QueryClient, pageSize: number) => {
    const queryCache = queryClient.getQueryCache();
    const pagesInView = queryCache.findAll({ queryKey: searchKeys.tablePages(), type: "active" });
    const pagesOutOfView = queryCache.findAll({ queryKey: searchKeys.tablePages(), type: "inactive" });

    const keptOutOfViewCount = Math.max(0, getMaxCachedSearchTablePages(pageSize) - pagesInView.length);
    const evictedCount = Math.max(0, pagesOutOfView.length - keptOutOfViewCount);

    if (evictedCount === 0) {
        return;
    }

    const evictedQueryHashes = new Set(
        [...pagesOutOfView]
            .sort(leastRecentlyFetchedFirst)
            .slice(0, evictedCount)
            .map(page => page.queryHash)
    );

    queryClient.removeQueries({
        queryKey: searchKeys.tablePages(),
        type: "inactive",
        predicate: page => evictedQueryHashes.has(page.queryHash),
    });
};
